import styled from 'styled-components';
import {
  StyledBaseModal,
  StyledBaseModalWrapper,
} from './components/Modal/BaseModal.component';
import {
  StyledInput,
  StyledInputContainer,
  StyledInputWrapper,
} from './components/Input/Input.component';

export const StyledTooltipWrapper = styled.div<{ left?: string }>`
  position: relative;

  :hover {
    .tooltip {
      visibility: visible;
      transition-delay: 0.5s;
      left: ${props => props.left};
      top: -3rem;
    }
  }
`;

export const StyledGlobalSearch = styled.div`
  ${StyledBaseModalWrapper} {
    flex-direction: column;
  }

  ${StyledBaseModal} {
    min-width: 670px;
  }

  ${StyledInputContainer} {
    gap: 0;
  }

  ${StyledInputWrapper} {
    padding: 0;
    height: 32px;
  }

  ${StyledInput} {
    width: 100%;
    font-size: 17px;
    line-height: 32px;
    font-weight: 500;
  }
`;

export const StyledDivider = styled.div`
  min-height: 1px;
  background-color: ${({ theme }) => theme.colors.BORDER};
  margin: 5px 0;
`;
